import React, { useState, useEffect } from 'react';
import { getRandomQuote } from '../../services/quotes';
import './InlineLoader.css';

interface InlineLoaderProps {
  message?: string;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({ message }) => {
  const [quote] = useState(getRandomQuote());
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setDotCount(p => (p + 1) % 4), 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="inline-loader">
      <div className="inline-loader__spinner">
        <div className="inline-loader__ring" />
        <div className="inline-loader__ring inline-loader__ring--2" />
        <div className="inline-loader__dot" />
      </div>
      {message && (
        <p className="inline-loader__message">{message}<span className="inline-loader__dots">{'.'.repeat(dotCount)}</span></p>
      )}
      <p className="inline-loader__quote">"{quote.text}"</p>
      <p className="inline-loader__author">— {quote.author}</p>
    </div>
  );
};

export default InlineLoader;
